import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import Flex from "components/Flex";
import { DIRECTION_CLASS, GAP_CLASS } from "components/Flex/Flex";
import { idPropType } from "constants/app";
import { modalTypes } from "constants/types";
import { arrayOf, func } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { selectProposalOutlineSections } from "slices/proposalOutline/selectors";
import { capitalize, pluralize } from "utils/string";

import classes from "./DeleteOutlineSectionsModal.module.scss";

const hideModalAction = hideModal(modalTypes.DELETE_OUTLINE_SECTIONS_MODAL);

const DeleteOutlineSectionsModal = ({
  finalTargetIds = [],
  onConfirmDelete,
}) => {
  const dispatch = useDispatch();
  const sections = useSelector(selectProposalOutlineSections);
  const sectionNoun = pluralize("section", finalTargetIds.length);
  const sectionVerb = finalTargetIds.length > 1 ? "are" : "is";

  const sectionsToDelete = sections.filter(({ id }) =>
    finalTargetIds.includes(id)
  );

  const totalTraces = sectionsToDelete.reduce((acc, s) => {
    return (acc += s.coveredPointIds?.length || 0);
  }, 0);

  const onClickConfirm = () => {
    dispatch(hideModalAction);
    onConfirmDelete();
  };

  const onDismiss = () => {
    dispatch(hideModalAction);
  };

  return (
    <Modal
      data-testid="choose-documents-modal"
      className="fade-in"
      show
      onDismiss={onDismiss}
      centered
    >
      <Modal.Header>Deleting Outline {capitalize(sectionNoun)}</Modal.Header>
      <Modal.Body className={classes.body}>
        <p>
          The following {sectionNoun} {sectionVerb} being deleted:
        </p>

        {totalTraces > 0 && (
          <p>
            Note, deleting the {sectionNoun} will also delete {totalTraces}{" "}
            traced requirements as well.
          </p>
        )}

        {sectionsToDelete.map((section) => {
          const { coveredPointIds, id, title } = section;
          const totalTraces = coveredPointIds?.length;
          const requirementNoun = pluralize("requirement", totalTraces);

          return (
            <Flex
              alignItems="flex-start"
              direction={DIRECTION_CLASS.column}
              gap={GAP_CLASS.GAP_200}
              key={id}
            >
              <strong>{title}</strong>
              {totalTraces > 0 && (
                <p>
                  Deleting this section will also remove {totalTraces} traced{" "}
                  {requirementNoun}{" "}
                  <em>({coveredPointIds.map((pId) => `${pId}`).join(", ")})</em>
                </p>
              )}
            </Flex>
          );
        })}
      </Modal.Body>
      <Modal.Footer>
        <NewButton
          data-testid="cancel-button"
          variant={NewButtonVariant.l2}
          onClick={onDismiss}
        >
          Cancel
        </NewButton>

        <NewButton
          data-testid="save-button"
          variant={NewButtonVariant.l1}
          onClick={onClickConfirm}
        >
          Confirm Delete
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

DeleteOutlineSectionsModal.propTypes = {
  finalTargetIds: arrayOf(idPropType),
  onConfirmDelete: func.isRequired,
};

export default DeleteOutlineSectionsModal;
